import LegalPageLayout from "@/components/LegalPageLayout";
import SEO from "@/components/SEO";

export default function RefundPolicy() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Refund & Cancellation Policy"
      updated="27 July 2026"
    >
      <SEO
        title="Refund & Cancellation Policy | Checkout DM"
        description="Checkout DM's refund and cancellation policy for merchant subscription plans and buyer orders placed via Instagram DM checkout."
        path="/refund-policy"
      />
      <p>
        This Refund & Cancellation Policy applies to CheckoutDM ("CheckoutDM,"
        "we," "us," "our"), operated by M/s Healthy Celeb, and forms part of
        our{" "}
        <a href="/terms-of-service">Terms of Service</a>
        .
      </p>

      <h2>1. Subscription fees are non-refundable</h2>
      <p>
        All CheckoutDM subscription fees — whether billed monthly or
        annually — are <strong>non-refundable</strong>, including for partial
        billing periods, unused time, or downgrades made mid-cycle. This
        applies from the moment a paid plan is activated.
      </p>

      <h2>2. Cancellation</h2>
      <p>
        You may cancel your subscription at any time from your Merchant
        dashboard. Cancellation stops future billing from the next cycle
        onward; you retain access to your current paid plan until the end of
        the billing period already paid for.
      </p>

      <h2>3. Duplicate or erroneous charges</h2>
      <p>
        The non-refundable policy above does not apply to billing errors on
        our part — for example, being charged twice for the same billing
        period, or charged after a subscription was already cancelled. In
        those cases, email us with your payment reference ID and we will
        correct the charge.
      </p>

      <h2>4. Buyer (Customer) orders</h2>
      <p>
        CheckoutDM is a technology facilitator connecting Merchants and their
        Customers — orders placed through a Merchant's Instagram DM are sold
        and fulfilled by that Merchant, not by CheckoutDM. Product refunds,
        exchanges, and order disputes must be resolved directly with the
        Merchant you purchased from. As described in our{" "}
        <a href="/terms-of-service">Terms of Service</a>
        , CheckoutDM does not hold, custody, or guarantee Customer funds and
        is not responsible for Merchant-Customer payment disputes.
      </p>

      <h2>5. Payment gateway charges</h2>
      <p>
        Any processing fees deducted by our payment provider (Razorpay) at
        the time of transaction are outside our control and are not
        refundable under any circumstance.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        For billing questions, contact{" "}
        <a href="mailto:billing@checkoutdm.com">billing@checkoutdm.com</a>.
        <br />
        #989, FF, Sector - 11, Panchkula, Haryana, India - 134112
      </p>
    </LegalPageLayout>
  );
}
